import { Output, EventEmitter, Directive } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';

@Directive()
export class LgvGridManager {

    public Page: number = 1;
    public ItemsPerPage: number = 50;
    public MaxPagerButtons: number = 10;
    public NumPages: number = 1;

    public TotalResultsValue: number = 500;
    get TotalResults(): number { return this.TotalResultsValue; }


    public DefaultSort: string;
    public CurrentSortColumn: string;
    public CurrentSortDirection: string = 'asc';

    @Output() OnRefreshData: EventEmitter<any> = new EventEmitter<any>();

    public config: any = {
        paging: true,
        filtering: { filterString: '' },
        className: ['table-striped', 'table-bordered']
    };

    public BaseQuery: string;

    get ODataSuffix(): string {
        let rtnVal: string = '';

        let skip: number = (this.Page - 1) * this.ItemsPerPage;

        //rtnVal += '&$inlinecount=allpages';
        rtnVal += '&$count=true';
        rtnVal += '&$skip=' + skip.toString();
        rtnVal += '&$top=' + this.ItemsPerPage.toString();
        rtnVal += '&$orderby=' + this.CurrentSortColumn;
        rtnVal += this.CurrentSortDirection == 'desc' ? '+desc' : '+asc';

        return rtnVal;
    }

    constructor() {
    }

    Init(defSort: string, direction = null) {
        this.DefaultSort = defSort;
        this.CurrentSortColumn = defSort;
        if (direction != null) {
            this.CurrentSortDirection = direction;
        }
    }

    OnSortChange(column: string, direction: string) {
        this.CurrentSortColumn = column;
        this.CurrentSortDirection = direction;
        this.OnRefreshData.emit({
            event: 'Grid_Sort_Event',
            data: {
                column,
                direction
            }
        });
    }

    public ResetPage() {
        this.Page = 1;
    }

    public OnChangeTable(config: any, pageEvent: PageEvent): any {
        //console.log('Page Event ***');
        //console.log(pageEvent);
        this.Page = pageEvent.pageIndex + 1;
        this.ItemsPerPage = pageEvent.pageSize;
        this.OnRefreshData.emit({
            event: 'Grid_Paging_Event',
            data: {
                page: this.Page,
            }
        });
    }

    public SetTotalResultSize(totalResults: number) {
        //this.NumPages = this.TotalResultsValue / this.ItemsPerPage;
        this.NumPages = Math.ceil(totalResults / this.ItemsPerPage);
        this.TotalResultsValue = totalResults;
    }

    public SortClientData(data: any[], prefix: string) {

        // could eventually make prefix a string array to check multiple

        let sortDirVal: number = this.CurrentSortDirection == 'asc' ? 1 : -1;
        if (this.CurrentSortColumn.startsWith(prefix)) {
            let sortCol = this.CurrentSortColumn.replace(prefix, '');
            let objName = prefix.replace('.', '');
            data.sort((x, y) => x[objName][sortCol] > y[objName][sortCol] ? sortDirVal : -sortDirVal);
        }
        else {
            data.sort((x, y) => x[this.CurrentSortColumn] > y[this.CurrentSortColumn] ? sortDirVal : -sortDirVal);
        }
    }

}

